import HomeView from './view/HomeView';
import AboutView from './view/AboutView';
import MarqueeInfinite from './fx/MarqueeInfinite';
import CarouselPress from './components/CarouselPress';
import MailMorph from './components/MailMorph';
import ScrollUp from './components/ScrollUp';
import CoverAbout from './components/CoverAbout';

const components = {
  "AboutView": AboutView,
  "HomeView": HomeView,
  "MarqueeInfinite": MarqueeInfinite,
  "CarouselPress": CarouselPress,
  "MailMorph": MailMorph,
  "ScrollUp": ScrollUp,
  "CoverAbout": CoverAbout,
}

export default components;
